import { GetMobDetParams } from "./../types/types";
import { useQuery } from "@tanstack/react-query";
import { getDetectDetail } from "../api/detect";
import { format } from "date-fns";

const useGetDetectDetail = ({
  startDate,
  endDate,
  event_code,
  searchKey,
  mobility_code,
  page,
  area,
  sort,
  limit,
  groupId,
}: GetMobDetParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "DetectDetail",
      `startDate-${startDate}`,
      `endDate-${endDate}`,
      `event_code-${event_code}`,
      `searchKey-${searchKey}`,
      `mobility_code-${mobility_code}`,
      `page-${page}`,
      `area-${area}`,
      `sort-${sort}`,
      `groupId-${groupId}`,
    ],
    queryFn: () =>
      getDetectDetail({
        startDate: format(startDate as Date, "yyyy-MM-dd"),
        endDate: format(endDate as Date, "yyyy-MM-dd"),
        page,
        searchKey,
        event_code,
        mobility_code,
        area,
        sort,
        limit,
        groupId,
      }),

    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isSuccess };
};

export default useGetDetectDetail;
